module.exports = __webpack_public_path__ + "static/media/icon-chevron-light.27c684ae.svg";